import { render, staticRenderFns } from "./AggiungiModificaStato.vue?vue&type=template&id=5f90ad06&"
import script from "./AggiungiModificaStato.vue?vue&type=script&lang=js&"
export * from "./AggiungiModificaStato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports